import { createBuilderModule } from '../../../builder';
import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { TwoColumnRiverSection } from './TwoColumnRiverSection';
import { COLOR_KEYS, ICON_NAMES } from '../../../constants';
import { DEFAULT_VALUES } from './fixtures';
import { withChildren } from '@builder.io/react';
import { imgElement } from '../../../builder/element-factories';

export default createBuilderModule(
  withChildren(
    withTracking(TwoColumnRiverSection, {
      as: 'section',
      sectionName: SectionName.TwoColumnRiverSection,
    }),
  ),
  {
    name: 'TwoColumnRiver',
    image: 'https://cdn.zappy.app/a60710d9fda3a9c0c68712739f625913.png', // Add
    inputs: [
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
        defaultValue: COLOR_KEYS.neutral100,
      },
      {
        name: 'heading',
        type: 'string',
        required: true,
        defaultValue: 'Edit me',
      },
      {
        name: 'description',
        type: 'richText',
        defaultValue: DEFAULT_VALUES.description,
      },
      {
        name: 'ctaText',
        type: 'string',
      },
      {
        name: 'ctaHref',
        type: 'string',
      },
      {
        name: 'ctaColor',
        type: 'string',
        enum: ['primary', 'primary-alt', 'secondary', 'brand'],
        showIf: (options) => options.get('ctaText') && options.get('ctaHref'),
      },
      {
        name: 'secondaryCtaText',
        type: 'string',
      },
      {
        name: 'secondaryCtaHref',
        type: 'string',
      },
      {
        name: 'isReversed',
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'labelIcon',
        type: 'string',
        enum: Object.values(ICON_NAMES),
      },
      {
        name: 'labelColor',
        type: 'string',
        enum: [
          'info',
          'success',
          'error',
          'warning',
          'white',
          'gray',
          'peach',
          'neutral300',
          'bolt',
          'cream',
        ],
      },
    ],
    defaultChildren: [
      imgElement({
        src: 'https://cdn.zappy.app/a676a6fd95275034143d3250133031a3.jpg',
        alt: 'Mountain view',
      }),
    ],
  },
);
